//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { SchoolEventPolicyCancellationDeadlineSettingsDisplayItem } from './SchoolEventPolicyCancellationDeadlineSettingsDisplayItem';
import { SchoolMakeUpCreditLimitSettingsDisplayItem } from './SchoolMakeUpCreditLimitSettingsDisplayItem';
import { SchoolEventPolicySignUpSettingsDisplayItem } from './SchoolEventPolicySignUpSettingsDisplayItem';

export class SchoolEventPolicySettingsDisplayItem extends ItemBase {
    CancellationPolicyText: string | null = null;
    CancellationDeadlineSettings: SchoolEventPolicyCancellationDeadlineSettingsDisplayItem | null = null;
    MakeUpCreditLimitSettings: SchoolMakeUpCreditLimitSettingsDisplayItem | null = null;
    MakeUpEventCategoryID: string | null = null;
    MakeUpCreditExpiryDays: number | null = null;
    SignUpSettings: SchoolEventPolicySignUpSettingsDisplayItem | null = null;

    constructor(initializer?: Partial<SchoolEventPolicySettingsDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolEventPolicySettingsDisplayItem";
}
